export const artistsPage = {
    'artists.card.image.title': '艺术家 - {shortId} | 在 R.Toys 上为您找到更多有趣的艺术家',
    'artists.page.title': '艺术家',
}
